import React, { PureComponent, Component } from 'react'

import Dialog from '@material-ui/core/Dialog'
import TextField from '@material-ui/core/TextField'

import DialogContent from "@material-ui/core/DialogContent";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogActions from '@material-ui/core/DialogActions'
import Button from '@material-ui/core/Button';
import Checkbox from '@material-ui/core/Checkbox';
import SelectList from '../SelectList'
import { alertActions } from '../../actions/alert.actions';
import { getFirebase } from 'react-redux-firebase'
import { dockPadEntityMapToList } from '../../containers/DockPadFormTemplates';
import { ConstraintStatus } from '../../utils/ConstraintStatus';
import { getNewId } from '../../actions/home.actions';
import { LookaheadTag, LookaheadTagStatus } from '../../models/LookaheadTag';
import { ClassNameMap } from '@material-ui/core/styles/withStyles';
import { Trade } from '../../models/Trade';
import moment, { Moment } from 'moment'
import { DatePicker } from "material-ui-pickers";
import classNames from 'classnames';
import VisibilityIcon from '@material-ui/icons/Visibility';
import IconButton from '@material-ui/core/IconButton';
import VisibilityOffIcon from '@material-ui/icons/VisibilityOff';
import { BatchData } from '../../models/BatchData';
const _ = require('lodash')

interface IFormLookaheadTag {
    tradeId: string | null,
    name: string | null,
    locationId: string | null,
    predecessorId: string | null,
    crewSize: number,
    constraintId: object | null
    goal: string | null,
    status: LookaheadTagStatus,
}

interface Props {

    isBatchTagDialogOpen: boolean,
    classes: ClassNameMap;
    closeTagDialogValue: () => Promise<void>;
    tradesSelectList: Record<string, string>;
    tagSelectList: Record<string, string>;
    trades: Record<string, Trade>;
    submitBatchValue: (batchData:BatchData) => Promise<void>;
    errorAlert: (message:string) => Promise<void>
}

type State = {
    tag: IFormLookaheadTag
    tagId?: string | null,
    newContraints: Record<string, object>;
    status: LookaheadTagStatus,
    duration: number | null,
    newLocation: string | null,
    isTradeVisible: boolean,
    isNameVisible: boolean,
    isLocationVisible: boolean,
    isPredecessorVisible: boolean,
    isCrewSizeVisible: boolean,
    isGoalVisible: boolean,
    isStatusVisible: boolean
}



class BatchTagDialog extends Component<Props, State> {
    constructor(props: Props) {
        super(props)
        this.state = {
            tagId: null,
            tag: {
                tradeId: null,
                name: null,
                locationId: null,
                predecessorId: null,
                crewSize: 1,
                constraintId: null,
                goal: null,
                status: LookaheadTagStatus.Todo,
            },
            duration: 1,
            newLocation: null
        }

    }


    shouldComponentUpdate(nextProps: Props, nextState: State) {
        
    
        if(!_.isEqual(nextState.tag, this.state.tag))  {
            return true
        }

        if(this.props.isBatchTagDialogOpen !== nextProps.isBatchTagDialogOpen) {
            nextState.tag = {
                tradeId: null,
                name: "",
                locationId: null,
                predecessorId: null,
                crewSize: 1,
                constraintId: null,
                goal: "",
                status: LookaheadTagStatus.Todo,
            }
            return true
        }

        
        if(this.state.newLocation !== nextState.newLocation) {
            return true
        }

        if(this.state.isTradeVisible !== nextState.isTradeVisible) {
            return true
        }

        if(this.state.isStatusVisible !== nextState.isStatusVisible) {
            return true
        }

        if(this.state.isPredecessorVisible !== nextState.isPredecessorVisible) {
            return true
        }

        if(this.state.isNameVisible !== nextState.isNameVisible) {
            return true
        }

        if(this.state.isLocationVisible !== nextState.isLocationVisible) {
            return true
        }

        if(this.state.isGoalVisible !== nextState.isGoalVisible) {
            return true
        }

        if(this.state.isCrewSizeVisible !== nextState.isCrewSizeVisible) {
            return true
        }
    
    
        return false
    }

    async closeDialog() {
        const { closeTagDialogValue } = this.props
        closeTagDialogValue()
    }

    onTradeChanged = (value: any) => {
        const tag = { ...this.state.tag }
        tag.tradeId = value.value
        this.setState({
            tag
        });
    }

    async onPredecessorChanged(value: any) {
        const tag = { ...this.state.tag }
        tag.predecessorId= value.value
        this.setState({
            tag
        });
    }  

    async onCrewSizeChange(event: any) {
        const tag = { ...this.state.tag }
        tag.crewSize = parseInt(event.target.value)
        this.setState({
            tag
        });
    }

    onDurationChange = async (event: any) => {
        const duration = parseInt(event.target.value)
        this.setState({
            duration
        });
    }

    async onNameChange(event: any) {
        const tag = { ...this.state.tag }
        tag.name = event.target.value
        this.setState({
            tag
        });
    }

    async onGoalChange(event: any) {
        const tag = { ...this.state.tag }
        tag.goal = event.target.value
        this.setState({
            tag
        });
    }


    async onSubmit() {
        const { 
            tag, 
            isTradeVisible, 
            isStatusVisible, 
            isPredecessorVisible, 
            isNameVisible,
            isLocationVisible,
            isGoalVisible,
            isCrewSizeVisible 
        } = this.state
        const { errorAlert, submitBatchValue } = this.props

        const batchData:BatchData = {}

        if(isNameVisible && !!tag.name) {
            batchData['name'] = tag.name
        }

        if(isTradeVisible && !!tag.tradeId) {
            batchData['tradeId'] = tag.tradeId
        }

        if(isStatusVisible && !!tag.status) {
            batchData['status'] = tag.status
        }

        if(isLocationVisible && !!tag.locationId) {
            batchData['locationId'] = tag.locationId
        }

        if(isCrewSizeVisible && !!tag.crewSize && tag.crewSize >= 0) {
            batchData['crewSize'] = tag.crewSize
        }

        if(isGoalVisible && !!tag.goal) {
            batchData['goal'] = tag.goal
        }

        if(isPredecessorVisible && !!tag.predecessorId) {
            batchData['predecessorId'] = tag.predecessorId
        }


        console.log('onSubmit', tag)

        submitBatchValue(batchData)

    }    

    async onLocationChanged(value:any) {
        const tag = { ...this.state.tag }
        const locationId = value.value

        tag.locationId = locationId

        this.setState({
            tag,
            newLocation: locationId
        });
    }

    getColor() {
        const { trades } = this.props
        const { tag } = this.state

        if(!tag.tradeId) {
            return '#000'
        }

        const trade = trades[tag.tradeId]

        return !!trade ? trade.color :  '#000'
    }

    getLookaheadStatusList = () => {
        return Object.entries(LookaheadTagStatus).map(([key,value]) => {
            return {
                uid: key,
                name: value
            }
        })
    }

    onStatusChanged = (value: any) => {
        const tag = { ...this.state.tag }
        tag.status = value.value
        this.setState({
            tag
        })
    }


    getLocationList = () => {
        const { newLocation } = this.state
        if(!newLocation) {
            return this.props.tagLocationsSelectList
        }

        const selectListing = [...this.props.tagLocationsSelectList, {
            uid: newLocation,
            name: newLocation}
        ]


        return selectListing
    }

    onTradeVisibleClick = () => {
        this.setState({
            isTradeVisible: !this.state.isTradeVisible
        })
    }

    onVisibleClick = (name: String) => {
        console.log('onVisibleClick', name)
        this.setState({
            [name]: !this.state[name]
        })
    }
    
    render() {
        const { isBatchTagDialogOpen, classes } = this.props;
        const { tag } = this.state
        const color = this.getColor()
        const formFieldVisible = classes.formFieldVisible
        return (
          <Dialog
            maxWidth='sm'
            fullWidth={true}
            open={!!isBatchTagDialogOpen}
            onBackdropClick={this.closeDialog.bind(this)}
          >
              <DialogContent>
                <div style={{backgroundColor: color}} className={classes.DialogFormTitle}>
                    <p className={classes.DialogFormTitleText}>
                        Batch Change
                    </p>
                </div>
                <div className={classes.DialogFormContent} >
                    <div 
                        style={{alignItems: 'flex-start'}} 
                        className={classNames(classes.DialogFormField, {
                            [formFieldVisible]: !this.state.isTradeVisible
                        })}
                    >
                        <p className={classes.DialogFormLabel}>Trade*</p>

                        <SelectList
                            onChange={this.onTradeChanged}
                            title=''
                            isMulti={false}
                            optionList={this.props.tradesSelectList}
                            value={tag.tradeId}
                        />
                        <IconButton onClick={this.onTradeVisibleClick}>
                            { 
                                (!this.state.isTradeVisible ? (
                                    <VisibilityOffIcon />
                                ):(
                                    <VisibilityIcon />
                                ))
                            }
                        </IconButton>
                    </div>
                    <div  className={classNames(classes.DialogFormField, {
                            [formFieldVisible]: !this.state.isNameVisible
                        })}
                    >
                        <p className={classes.DialogFormLabel}>Task*</p>
                        <TextField
                            onChange={this.onNameChange.bind(this)}
                            required
                            defaultValue={tag.name}
                            fullWidth={true}
                        />
                        <IconButton onClick={()=> this.onVisibleClick('isNameVisible')}>
                            { 
                                (!this.state.isNameVisible ? (
                                    <VisibilityOffIcon />
                                ):(
                                    <VisibilityIcon />
                                ))
                            }
                        </IconButton>
                    </div>
                    <div style={{alignItems: 'flex-start'}} className={classNames(classes.DialogFormField, {
                            [formFieldVisible]: !this.state.isLocationVisible
                        })}>
                        <p className={classes.DialogFormLabel}>Location*</p>

                        <SelectList
                            onChange={this.onLocationChanged.bind(this)}
                            createOption={true}
                            title=''
                            isMulti={false}
                            optionList={this.getLocationList()}
                            value={tag.locationId}
                        />
                        <IconButton onClick={()=> this.onVisibleClick('isLocationVisible')}>
                            { 
                                (!this.state.isLocationVisible ? (
                                    <VisibilityOffIcon />
                                ):(
                                    <VisibilityIcon />
                                ))
                            }
                        </IconButton>
                    </div>
                    <div style={{alignItems: 'flex-start'}} className={classNames(classes.DialogFormField, {
                            [formFieldVisible]: !this.state.isStatusVisible
                        })}
                    >
                        <p className={classes.DialogFormLabel}>Status</p>

                        <SelectList
                            onChange={this.onStatusChanged.bind(this)}
                            title=''
                            isMulti={false}
                            optionList={this.getLookaheadStatusList()}
                            value={(!!tag.status && !!LookaheadTagStatus[tag.status]) ? tag.status : LookaheadTagStatus.Todo}
                        />
                        <IconButton onClick={()=> this.onVisibleClick('isStatusVisible')}>
                            { 
                                (!this.state.isStatusVisible ? (
                                    <VisibilityOffIcon />
                                ):(
                                    <VisibilityIcon />
                                ))
                            }
                        </IconButton>
                    </div>
                    <div style={{alignItems: 'flex-start'}} className={classNames(classes.DialogFormField, {
                            [formFieldVisible]: !this.state.isPredecessorVisible
                        })}>
                        <p className={classes.DialogFormLabel}>Predecessor</p>

                        <SelectList
                            onChange={this.onPredecessorChanged.bind(this)}
                            title=''
                            isMulti={false}
                            optionList={this.props.tagSelectList}
                            value={tag.predecessorId}
                        />
                        <IconButton onClick={()=> this.onVisibleClick('isPredecessorVisible')}>
                            { 
                                (!this.state.isPredecessorVisible ? (
                                    <VisibilityOffIcon />
                                ):(
                                    <VisibilityIcon />
                                ))
                            }
                        </IconButton>
                    </div>
                    
                    <div className={classNames(classes.DialogFormField, {
                            [formFieldVisible]: !this.state.isCrewSizeVisible
                        })}
                    >
                        <p className={classes.DialogFormLabel}>Crew Size</p>
                        <TextField
                            onChange={this.onCrewSizeChange.bind(this)}
                            required
                            defaultValue={tag.crewSize}
                            type="number"
                            fullWidth={true}
                        />
                        <IconButton onClick={()=> this.onVisibleClick('isCrewSizeVisible')}>
                            { 
                                (!this.state.isCrewSizeVisible ? (
                                    <VisibilityOffIcon />
                                ):(
                                    <VisibilityIcon />
                                ))
                            }
                        </IconButton>
                    </div>
                        
                    <div className={classNames(classes.DialogFormField, {
                            [formFieldVisible]: !this.state.isGoalVisible
                        })}
                    >
                        <p className={classes.DialogFormLabel}>Goal</p>
                        <TextField
                            onChange={this.onGoalChange.bind(this)}
                            defaultValue={tag.goal}
                            fullWidth={true}
                        />
                        <IconButton onClick={()=> this.onVisibleClick('isGoalVisible')}>
                            { 
                                (!this.state.isGoalVisible ? (
                                    <VisibilityOffIcon />
                                ):(
                                    <VisibilityIcon />
                                ))
                            }
                        </IconButton>
                    </div>
                </div>
              </DialogContent>
              <DialogActions>
                <Button onClick={this.closeDialog.bind(this)} color="secondary"> Cancel </Button>
                <Button onClick={this.onSubmit.bind(this)}  color="primary"> Confirm </Button>

                
              </DialogActions>
          </Dialog>
        )
    }
    
}


export default BatchTagDialog
  


// WEBPACK FOOTER //
// ./src/components/Dialogs/BatchTagDialog.tsx